import { HttpResponse } from '@/utils/http-utils';
import siteConfigService from '@/services/site.config.service';
import storageService from '@/services/storage.service';
import httpService from '@/services/http.service';
import StringUtil from '@/utils/string-utils';
import { CacheConfig } from '@/entities/cache';
import store from '@/store';
import MessagesUtils from '@/utils/messages-utils';
import Logger from '@/utils/logger.utils';
import JSONUtils from '@/utils/json-utils';
import cacheService from './cache.service';


class MessageBundleService {
  private messageBundleApiEndpointKeyName: string = 'generic.messageBundle';
  private emptyVehicleImageKeyName: string = 'common.vehicle.empty.image';

  public async getMessageFromStore(key: string, ...args: any): Promise<string> {
    return MessagesUtils.getMessage(store.getters['mainModule/messages'], key, args);
  }
  public async getMessages(): Promise<Map<string, string>> {
    const languageCode: string = await storageService.getLanguageCode();
    const messages: any = await this.getMessagesInternal() || {};
    const emptyVehicleImageUrl: string = messages[this.emptyVehicleImageKeyName];
    if (!emptyVehicleImageUrl || emptyVehicleImageUrl.indexOf('=null') >= 0) {
      if (languageCode.toLocaleLowerCase().startsWith('fr')) {
        messages[this.emptyVehicleImageKeyName] = './img/common/vehicleNotAvaFr.svg';
      } else {
        messages[this.emptyVehicleImageKeyName] = './img/common/vehicleNotAvaEn.svg';
      }
    }
    return messages;
  }

  private async getMessagesInternal(): Promise<Map<string, string>> {
    const languageCode: string = await storageService.getLanguageCode();

    const plId: number = await storageService.getPrivateLabelId();

    const cacheName: string = 'localization';
    const cacheKey: string = `${plId}_${languageCode}`;
    const cacheConfig: CacheConfig = {
      name: cacheName,
      key: cacheKey,
      options: {
        cacheKeepOneKeyOnly: true,
        timeToLive: -1,
        forceUpdate: false,
        secondLevel: true,
      },
    };
    /** let's fist check in cache, if not present then take from API */
    const msgs: Map<string, string> = await cacheService.getItem(cacheConfig.name, cacheConfig.key, cacheConfig.options);
    if (msgs) {
      return Promise.resolve(msgs);
    }
    /** We didn't find messages into cache storage so let's take from API */
    const retMessages: Map<string, string> = await this.getMessagesFromApi();
    /** Now set message bundle into cache storage */
    if (retMessages) {
      await cacheService.setItem(cacheConfig.name, cacheConfig.key, retMessages, cacheConfig.options);
    }
    return Promise.resolve(retMessages);
  }
  private async getMessagesFromApi(): Promise<Map<string, string>> {
    const languageCode: string = await storageService.getLanguageCode();
    let apiEndpoint: any = await siteConfigService.getApiEndpoint(this.messageBundleApiEndpointKeyName);
    apiEndpoint = apiEndpoint.replace('{languageCode}', languageCode);
    apiEndpoint = apiEndpoint.replace(`{${StringUtil.getMiddle(apiEndpoint, '{', '}')}}`, 'all');
    const msgMapResp: HttpResponse<Map<string, string>> = await httpService.get(apiEndpoint);
    const messages: any = msgMapResp.data;
    try {
      return Promise.resolve(JSONUtils.parse(messages));
    } catch (e) {
      Logger.warn('received response of messages is not a valid json type');
      return Promise.resolve(undefined);
    }
  }
}

// Export a singleton instance in the global namespace
export default new MessageBundleService();
